module.exports = __webpack_public_path__ + "static/media/main4_zh_768-min.eb6e4162.png";